import request from '@/axios';

/** 获取列表 */
export const getList = (params) => {
  return request({
    url: '/lebo-card/appScreenCastConfig/page',
    method: 'get',
    params
  });
};

/** 新增配置 */
export const addConfig = (data) => {
  return request({
    url: '/lebo-card/appScreenCastConfig/save',
    method: 'post',
    data
  });
};

/** 修改配置 */
export const updateConfig = (data) => {
  return request({
    url: '/lebo-card/appScreenCastConfig/update',
    method: 'post',
    data
  });
};

/** 删除配置 */
export const deleteConfig = (id) => {
  return request({
    url: '/lebo-card/appScreenCastConfig/remove',
    method: 'post',
    params: {
      ids: id
    }
  });
};

/** 获取配置详情 */
export const getDetail = (id) => {
  return request({
    url: '/lebo-card/appScreenCastConfig/info',
    method: 'get',
    params: {
      id
    }
  });
};

/** 获取操作日志 */
export const getLogList = (params) => {
    return request({
      url: "/lebo-card/web/card/operation-log/page",
      method: "get",
      params: {
        ...params,
        module: 5
      }
    });
};

/** 获取组件类型列表 */
export const getComponentTypeList = () => {
  return request({
    url: '/lebo-system/dict-biz/dictionary',
    method: 'get',
    params: {
      code: 'APP_SCREEN_RESPONSE_TYPE'
    }
  });
};